import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FEEDBACK_EVENT_OPTIONS } from '../config/event-registration-config';
import { submitFeedback } from '../utils/sheets-api';
import { SHEETS_CONFIG } from '../config/sheets-config';
import './Feedback.css';

const Feedback = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    parent_name: '',
    child_name: '',
    event_attended: '',
    feedback_message: '',
    rating: '',
    email: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess(false);

    try {
             // Check if Google Sheets is configured
       if (SHEETS_CONFIG.SCRIPT_URL === 'YOUR_SCRIPT_URL') {
         // Demo mode - show success message but don't actually submit
         setSuccess(true);
         setFormData({
           parent_name: '',
           child_name: '',
           event_attended: '',
           feedback_message: '',
           rating: '',
           email: ''
         });
         
         setTimeout(() => {
           navigate('/');
         }, 3000);
         return;
       }

                    // Debug: Log what we're sending
        console.log('Submitting feedback data:', formData);
        console.log('All form fields:', {
          feedback_message: formData.feedback_message,
          rating: formData.rating,
          event_attended: formData.event_attended,
          parent_name: formData.parent_name,
          child_name: formData.child_name,
          email: formData.email
        });
      
      // Submit to Google Sheets using the utility function
      const result = await submitFeedback(formData);
      
             if (result.success) {
         setSuccess(true);
         setFormData({
           parent_name: '',
           child_name: '',
           event_attended: '',
           feedback_message: '',
           rating: '',
           email: ''
         });
         
         // Show success message for 3 seconds then redirect
         setTimeout(() => {
           navigate('/');
         }, 3000);
       } else {
        throw new Error(result.error || 'Failed to submit feedback');
      }
    } catch (error) {
      console.error('Feedback submission error:', error);
      
      if (error.message.includes('Failed to fetch')) {
        setError('⚠️ Network error: Unable to connect to the feedback system. Please check your internet connection and try again.');
      } else if (error.message.includes('HTTP error')) {
        setError('⚠️ Server error: The feedback system is temporarily unavailable. Please try again in a few minutes.');
      } else {
        setError('⚠️ Feedback submission failed: ' + (error.message || 'Please try again or contact us directly.'));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="feedback">
      <div className="container">
        <section className="section">
          <h2>Share Your Experience</h2>
          
          <div className="card">
            <h3>We'd Love to Hear From You! 🌊</h3>
            <p>Your feedback helps us improve and inspires other families to join our swimming community. Share your experience and help us make a difference!</p>
          </div>
          
          {success && (
            <div className="card success-message">
              <h3>🎉 Thank You!</h3>
              <p>Your feedback has been submitted successfully! We appreciate you sharing your experience with our swimming community.</p>
              <p>Redirecting you to the home page...</p>
            </div>
          )}
          
          {error && (
            <div className="card error-message">
              <h3>❌ Error</h3>
              <p>{error}</p>
              <p>If the problem persists, please try again later or contact us directly.</p>
            </div>
          )}
          
          {!success && (
            <div className="card">
              <h3>Feedback Form</h3>
              <form onSubmit={handleSubmit} className="feedback-form">
                <div className="form-group">
                  <label htmlFor="feedback_message">Your Experience & Feedback *</label>
                  <textarea
                    id="feedback_message"
                    name="feedback_message"
                    rows="5"
                    placeholder="Tell us about your experience! What did your child learn? How did the coaches help? Any memorable moments? Is there anything we could improve?"
                    value={formData.feedback_message}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="rating">How would you rate your experience? *</label>
                  <select
                    id="rating"
                    name="rating"
                    value={formData.rating}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select rating...</option>
                    <option value="5">⭐⭐⭐⭐⭐ Excellent</option>
                    <option value="4">⭐⭐⭐⭐ Very Good</option>
                    <option value="3">⭐⭐⭐ Good</option>
                    <option value="2">⭐⭐ Fair</option>
                    <option value="1">⭐ Poor</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="event_attended">Which event did you attend? *</label>
                  <select
                    id="event_attended"
                    name="event_attended"
                    value={formData.event_attended}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select an event...</option>
                    {FEEDBACK_EVENT_OPTIONS.map((eventName) => (
                      <option key={eventName} value={eventName}>
                        {eventName}
                      </option>
                    ))}
                  </select>
                </div>
                
                
                
                <div className="form-group">
                  <label htmlFor="parent_name">Your Name (Optional)</label>
                  <input
                    type="text"
                    id="parent_name"
                    name="parent_name"
                    value={formData.parent_name}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="child_name">Child's Name (Optional)</label>
                  <input
                    type="text"
                    id="child_name"
                    name="child_name"
                    value={formData.child_name}
                    onChange={handleInputChange}
                  />
                </div>
                
                                                  <div className="form-group">
                   <label htmlFor="email">Email (Optional)</label>
                   <input
                     type="email"
                     id="email"
                     name="email"
                     value={formData.email}
                     onChange={handleInputChange}
                     placeholder="For follow-up questions or updates"
                   />
                 </div>
                 
              
                 <button 
                   type="submit" 
                   className="submit-feedback-btn"
                   disabled={submitting}
                 >
                   {submitting ? 'Submitting...' : 'Share My Experience 🌊'}
                 </button>
              </form>
            </div>
          )}
        </section>
      </div>
      
      <div className="back-buttons">
        <button onClick={() => navigate('/')} className="back-btn">
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default Feedback; 